export const baseUrl = process.env.NODE_ENV === 'production' ? 'https://leanlauri.github.io/localnotes' : 'http://localhost:3000';
export const basePath = process.env.NODE_ENV === 'production' ? '/localnotes' : undefined;
